import { EditOutlined } from '@ant-design/icons';
import { Flex, Modal, Form, Typography, Button, Input } from 'antd';
import React, { useState } from 'react';
import { WhatsappGroup } from 'src/interfaces/entities/whatsappGroup';
import {
	useGetWhatsappGroupsQuery,
	usePutGroupMutation
} from 'src/redux/services/centralApi';

import { useForm } from 'antd/es/form/Form';
import { toast } from 'react-toastify';

interface IForm {
	nome: string;
}

export default function EditGroup({ row, }: { row: WhatsappGroup }) {
	const [ open, setOpen, ] = useState<boolean>(false);
	const [ form, ] = useForm<IForm>();
	const [ avatar, setAvatar, ] = useState<string | undefined>(undefined);
	const [ avatarFileName, setAvatarFileName, ] = useState<string>('');
	const [ initialGroupName, setInitialGroupName, ] = useState<string>('');

	const [ putGroup, putGroupResult, ] = usePutGroupMutation();
	const { refetch: refetchGroups, } = useGetWhatsappGroupsQuery();

	const resetState = () => {
		setAvatar(undefined);
		setAvatarFileName('');
		setInitialGroupName('');
	};

	const onFinishForm = async () => {
		const formValues = form.getFieldsValue();
		const currentGroupName = formValues.nome;

		const nameChanged = currentGroupName !== initialGroupName;
		const avatarChanged = avatar !== undefined;

		if (!nameChanged && !avatarChanged) {
			toast.info('Nenhuma alteração foi detectada!', { autoClose: 1000, });
			return;
		}

		try {
			const putGroupPayload: { groupId: string; name?: string; avatar?: string } = {
				groupId: row.groupId ?? '',
			};

			if (nameChanged) {
				putGroupPayload.name = currentGroupName;
			}

			if (avatarChanged) {
				putGroupPayload.avatar = avatar;
			}

			await putGroup(putGroupPayload).unwrap();
			await refetchGroups();

			toast.success('Grupo atualizado com sucesso!', { autoClose: 1000, });

			setOpen(false);
			resetState();
		} catch (err: any) {
			if (
				err?.status &&
				err?.status === 500 &&
				err?.data?.frontend_message
			) {
				toast.error(err?.data?.frontend_message, { autoClose: 1000, });
			}
		}
	};

	const handleOpenModal = () => {
		setInitialGroupName(row.name || '');
		form.setFieldsValue({ nome: row.name || '', });
		setAvatar(undefined);
		setAvatarFileName('');
		setOpen(true);
	};

	const handleAvatarChange = () => {
		const input = document.createElement('input');
		input.type = 'file';
		input.accept = 'image/*';
		input.onchange = (event) => {
			const file = (event.target as HTMLInputElement).files?.[0];
			if (file) {
				const reader = new FileReader();
				reader.onload = () => {
					setAvatar(reader.result as string);
					setAvatarFileName(file.name);
				};
				reader.readAsDataURL(file);
			}
		};
		input.click();
	};

	return (
		<>
			<Button type="text" onClick={handleOpenModal} icon={<EditOutlined />} />
			<Modal
				centered
				title={'Editar Grupo do Whatsapp'}
				open={open}
				onCancel={() => {
					setOpen(false);
					resetState();
					toast.info('Operação cancelada!', { autoClose: 1000, });
				}}
				destroyOnHidden
				okText="Aplicar"
				onOk={() => form.submit()}
				confirmLoading={!!putGroupResult?.isLoading}
			>
				<Flex align="center" gap={12} style={{ marginBottom: 12, }}>
					<Button type="default" onClick={handleAvatarChange}>
						Carregar imagem do grupo
					</Button>
					{avatarFileName && (
						<Typography.Text type="success">
							📎 {avatarFileName}
						</Typography.Text>
					)}
				</Flex>
				<Form form={form} layout="vertical" onFinish={onFinishForm}>
					<Form.Item
						name={'nome'}
						label={'Nome'}
						tooltip={'Nome do grupo do WhatsApp'}
						rules={[
							{
								required: true,
								message: 'Por favor, insira o nome do grupo.',
							},
						]}
					>
						<Input placeholder="Digite o nome do grupo" />
					</Form.Item>
				</Form>
			</Modal>
		</>
	);
}
